import clsx from 'clsx';
import React from 'react';
import Button from '../../components/Button';
import ChevronLeftIcon from '../../assets/icons/chevron-down-icon.svg?react';
import ReportIcon from '../../assets/icons/report-icon.svg?react';
import { Link } from 'react-router';
import ChevronIcon from '../../assets/icons/chevron-down-icon.svg?react';
import { useButtonSizeLarge } from '../../utils/buttonSizes';
import { formatDate } from '../../utils/dateFormat';
import { formatTime } from '../../utils/timeFomat';
import EditIcon from '../../assets/icons/edit-icon.svg?react';
import {
  CorrectiveActionsPriorityEnum,
  GetIncidentByIdResponse,
} from '@EHSNavigator/backend';
import SaveAsDraft from '../../components/SaveAsDraft';

interface IncidentReviewDetailStepTwoProps {
  otherClasses?: string;
  formHandler: any;
  handleSteps: React.Dispatch<number>;
  departments: { label: string; value: string }[];
  userList: { label: string; value: string }[];
  data: GetIncidentByIdResponse['incident'];
  allDraftIncidentReviewsLength: number | undefined;
  handleDraft: () => void;
  isDraftLoading?: boolean;
  disbaleButtons?: boolean;
}

const IncidentReviewDetailStepTwo: React.FC<
  IncidentReviewDetailStepTwoProps
> = ({
  otherClasses,
  formHandler,
  handleSteps,
  departments,
  userList,
  data,
  allDraftIncidentReviewsLength,
  handleDraft,
  isDraftLoading,
  disbaleButtons,
}) => {
  const incidentReviewDetailStepTwoClasses = clsx(otherClasses);
  const lg = useButtonSizeLarge();

  return (
    <div
      className={incidentReviewDetailStepTwoClasses}
      data-testid="incident-review-detail-step-two"
    >
      <div className="flex flex-col items-start gap-2.5">
        <div className="flex w-full flex-wrap items-center justify-between gap-5">
          <Button
            type="button"
            onClick={() => handleSteps(2)}
            variant="link"
            otherClasses="gap-2.5 w-fit "
          >
            <span className="bg-brand-byzantine rounded-5 flex h-8 w-8 justify-center">
              <ChevronLeftIcon className="h-7 w-7 rotate-90 [&>path]:fill-white" />
            </span>
            <strong>Return</strong>
          </Button>
          <div className="flex items-center gap-3 sm:gap-5">
            <SaveAsDraft
              otherClasses="!mt-0 !py-0 border-y-transparent"
              handleSaveAsDraft={handleDraft}
              isDisabled={isDraftLoading}
              disbaleButtons={disbaleButtons}
            />
            <Button
              variant="secondary"
              size={lg}
              href="/incident-review/drafts"
              otherClasses="relative"
            >
              <EditIcon className="h-6 w-6 [&>path]:fill-current" /> All Drafts{' '}
              {allDraftIncidentReviewsLength && (
                <span className="text-brand-posh-pink">
                  {`(${allDraftIncidentReviewsLength})`}
                </span>
              )}
            </Button>
          </div>
        </div>

        <h1 className="h3 mb-1 lg:mb-0">Review Corrective Action</h1>
        <p className="text-brand-byzantine font-inter-variable -tracking-button text-base leading-5 font-bold lg:text-xl lg:leading-6">
          STEP 2 / 2
        </p>
      </div>
      <div className="border-y-neutral-tones-text/10 my-6 border-y py-5 lg:my-9">
        <div className="bg-card-backgrounds/5 border-neutral-tones-text/10 rounded-10 flex w-full items-center gap-2.5 border p-15">
          <ReportIcon className="[&>path]:fill-brand-fair-orange h-12 w-12 md:h-9 md:w-9 lg:h-12 lg:w-12" />
          <div className="flex flex-1 flex-col gap-1 lg:gap-2.5">
            <span className="font-inter-variable text-brand-fair-orange -tracking-form-input lg:-tracking-button text-base leading-5 font-medium lg:text-xl lg:leading-6 lg:font-bold">
              Linked Incident
            </span>
            <div className="flex items-center gap-15">
              <p className="text-neutral-tones-text -tracking-form-input lg:-tracking-text-area text-base leading-5 font-bold capitalize lg:text-lg lg:leading-5">
                {data?.title}
              </p>
              <span className="border-l-neutral-tones-text/10 hidden h-5 border-l lg:block"></span>
              <p className="font-inter-variable text-neutral-tones-text/80 -tracking-form-label lg:-tracking-form-input hidden text-sm leading-5 font-normal whitespace-nowrap lg:block lg:text-base">
                Reference ID{' '}
                <span className="text-neutral-tones-text/50 uppercase">
                  {data?.incidentRefId}
                </span>
              </p>
            </div>
          </div>
          <Link target="_blank" to={`/my-reported-incidents/${data?.id}`}>
            <ChevronLeftIcon className="[&>path]:fill-neutral-tones-text h-6 w-6 -rotate-90 md:h-12 md:w-12" />
          </Link>
        </div>
      </div>
      <div className="pb-6 lg:pb-9">
        <div className="grid grid-cols-1 items-start justify-between gap-6 md:grid-cols-3 md:gap-10 lg:justify-start lg:gap-5 2xl:gap-10">
          <div className="flex flex-col">
            <h6 className="font-inter-variable text-brand-byzantine -tracking-button mb-5 text-lg leading-5 font-bold lg:text-xl lg:leading-6">
              Due Date & Time
            </h6>
            <div className="flex items-start gap-75 md:gap-12 lg:gap-6 2xl:gap-75">
              <div className="flex flex-col gap-2.5">
                <h6 className="text-neutral-tones-text -tracking-form-input lg:-tracking-button font-inter-variable text-base leading-6 font-bold lg:text-xl lg:leading-6">
                  Date
                </h6>
                <p className="font-inter-variable text-neutral-tones-text -tracking-form-input text-base leading-5 font-normal">
                  {formatDate(formHandler?.values?.date)}
                </p>
              </div>
              <div className="flex flex-col gap-2.5">
                <h6 className="text-neutral-tones-text -tracking-form-input lg:-tracking-button font-inter-variable text-base leading-6 font-bold lg:text-xl lg:leading-6">
                  Time
                </h6>
                <p className="font-inter-variable text-neutral-tones-text -tracking-form-input text-base leading-5 font-normal">
                  {formatTime(formHandler?.values?.time)}
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col">
            <h6 className="font-inter-variable text-brand-byzantine -tracking-button mb-5 text-lg leading-5 font-bold lg:text-xl lg:leading-6">
              Assignee
            </h6>
            <div className="grid grid-cols-2 items-start gap-6 lg:grid-cols-1 xl:grid-cols-2 2xl:gap-x-60">
              <div className="flex flex-col gap-2.5">
                <h6 className="text-neutral-tones-text -tracking-form-input lg:-tracking-button font-inter-variable text-base leading-6 font-bold lg:text-xl lg:leading-6">
                  Department
                </h6>
                <p className="font-inter-variable text-neutral-tones-text -tracking-form-input text-base leading-5 font-normal">
                  {
                    departments?.find(
                      (node) => node?.value === formHandler?.values?.department,
                    )?.label
                  }
                </p>
              </div>
              <div className="flex flex-col gap-2.5">
                <h6 className="text-neutral-tones-text -tracking-form-input lg:-tracking-button font-inter-variable text-base leading-6 font-bold lg:text-xl lg:leading-6">
                  Assignee
                </h6>
                <p className="font-inter-variable text-neutral-tones-text -tracking-form-input text-base leading-5 font-normal capitalize">
                  {formHandler?.values?.assignee
                    ?.map(
                      (item: any) =>
                        userList?.find((user) => user.value === item)?.label,
                    )
                    .join(', ')}
                </p>
              </div>
              {formHandler?.values?.leadAssignee && (
                <div className="col-span-2 flex flex-col gap-2.5 lg:col-span-1 xl:col-span-2">
                  <h6 className="text-neutral-tones-text -tracking-form-input lg:-tracking-button font-inter-variable text-base leading-6 font-bold lg:text-xl lg:leading-6">
                    Lead Assignee
                  </h6>
                  <p className="font-inter-variable text-neutral-tones-text -tracking-form-input text-base leading-5 font-normal capitalize">
                    {
                      userList?.find(
                        (user) =>
                          user.value === formHandler?.values?.leadAssignee,
                      )?.label
                    }
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col">
            <h6 className="font-inter-variable text-brand-byzantine -tracking-button mb-5 text-lg leading-5 font-bold lg:text-xl lg:leading-6">
              Priority
            </h6>
            <h3
              className={clsx(
                'uppercase',
                formHandler?.values?.actionPriority ===
                  CorrectiveActionsPriorityEnum.Urgent
                  ? 'text-brand-posh-pink'
                  : formHandler?.values?.actionPriority ===
                      CorrectiveActionsPriorityEnum.High
                    ? 'text-brand-fair-orange'
                    : formHandler?.values?.actionPriority ===
                        CorrectiveActionsPriorityEnum.Medium
                      ? 'text-primary-yellow'
                      : 'text-brand-papery',
              )}
            >
              {formHandler?.values?.actionPriority}
            </h3>
          </div>
        </div>
      </div>
      <div className="border-y-neutral-tones-text/10 border-y py-8">
        <div className="flex max-w-625 flex-col">
          <h6 className="font-inter-variable text-brand-byzantine -tracking-button mb-5 text-lg leading-5 font-bold lg:text-xl lg:leading-6">
            Action Title
          </h6>
          <p className="text-neutral-tones-text -tracking-form-input font-inter-variable text-base leading-5 font-normal capitalize italic">
            {formHandler?.values?.actionTitle}
          </p>
        </div>
        <div className="mt-8 flex max-w-625 flex-col">
          <h6 className="font-inter-variable text-brand-byzantine -tracking-button mb-5 text-lg leading-5 font-bold lg:text-xl lg:leading-6">
            Action Description
          </h6>
          <p className="text-neutral-tones-text -tracking-form-input font-inter-variable text-base leading-5 font-normal capitalize italic">
            {formHandler?.values?.description}
          </p>
        </div>
      </div>
      <div className="mt-12 flex items-center gap-8">
        <Button
          onClick={() => handleSteps(2)}
          size={useButtonSizeLarge()}
          variant="secondary"
          otherClasses="max-w-211 w-full"
        >
          <ChevronIcon className="h-5 w-5 rotate-90 [&>path]:fill-current" /> Go
          Back
        </Button>
        <Button
          size={useButtonSizeLarge()}
          otherClasses="max-w-211 w-full"
          loading={formHandler?.isSubmitting}
          disable={formHandler?.isSubmitting}
          onClick={() => formHandler?.handleSubmit()}
        >
          Complete{' '}
          <ChevronIcon className="h-5 w-5 -rotate-90 [&>path]:fill-current" />
        </Button>
      </div>
    </div>
  );
};

export default IncidentReviewDetailStepTwo;
